<template>
  <div>
    <div style="display: none">
      <EditDialog
        v-bind:model="editRisk"
        v-bind:moduleName="'risks'"
        v-bind:btnName="''"
        v-bind:formTitle="$t('risks.actions.add_item')"
        @save="saveRiskEvent"
        @close="cleanupRiskDialog"
        ref="editDialogRisk"
      >
        <template v-slot:edit_content>
          <RiskForm :newRisk="newRisk"></RiskForm>
        </template>
      </EditDialog>
    </div>
    <v-btn
      class="risk-btn"
      color="error"
      variant="flat"
      rounded="pill"
      size="large"
      @click="openEditRisk()"
    >
      <span class="risk-btn__icon">
        <v-icon size="18">mdi-alert-outline</v-icon>
      </span>
      {{ $filters.capitalize($t(`risks.actions.add_item`)) }}
    </v-btn>
  </div>
</template>

<script>
import i18n from "@/i18n";
import { slicyUpdate, isNone } from "@/functions";

import filters from "@/mixins/filters";
import EditDialog from "@/components/EditDialog";
import RiskForm from "@/components/RiskForm";

export default {
  props: {
    newRisk: { type: Boolean, required: false, default: true },
  },
  mixins: [filters],
  components: {
    EditDialog,
    RiskForm,
  },
  computed: {
    editedItem: function () {
      return this.$store.getters.dataEdit(this.moduleName);
    },
    risk_edit: function () {
      return this.$store.state["risks"].edit;
    },
  },
  methods: {
    openEditRisk() {
      this.$store.dispatch(
        `risks/updateEdit`,
        this.$store.state["risks"].struct,
      );
      this.editRisk = true;
    },
    saveRiskEvent() {
      return this.$store.dispatch(`risks/addItem`, this.risk_edit).then(() => {
        slicyUpdate(this.risks, this.risk_edit);
        this.$refs.editDialogRisk.closeDialog();
        this.$emit("reload");
      });
    },
    cleanupRiskDialog() {
      this.editRisk = false;
      this.$store.dispatch(
        `risks/updateEdit`,
        this.$store.state["risks"].struct,
      );
    },
  },

  data() {
    return {
      moduleName: "risks",
      btnText: this.$t("home.risk"),
      editRisk: false,
      risks: [],
    };
  },
};
</script>

<style scoped>
/* A button that reads as an alert: red gradient, icon in a white disc, lifts on hover */
.risk-btn {
  text-transform: none;
  letter-spacing: 0.01em;
  font-weight: 700;
  padding-left: 8px;
  padding-right: 20px;
  background: linear-gradient(135deg, #e53935 0%, #c62828 100%) !important;
  box-shadow: 0 4px 12px rgba(198, 40, 40, 0.3);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}
.risk-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(198, 40, 40, 0.38);
}
.risk-btn__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  margin-right: 10px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.22);
}
</style>
